.header {
  top: 0;
  margin-right: calc(-1 * var(--rc-theme-react-components-modal-scrollable-padding-lg));
  margin-left: calc(-1 * var(--rc-theme-react-components-modal-scrollable-padding-lg));
  padding-top: var(--rc-theme-react-components-modal-scrollable-padding-md);
  padding-right: var(--rc-theme-react-components-modal-scrollable-padding-md);
  padding-left: var(--rc-theme-react-components-modal-scrollable-padding-md);
  border-bottom: 1px solid var(--rc-theme-color-border-default);
}
